import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/edit.svg'
import _imports_1 from '@/assets/icons/trash.svg'
import _imports_2 from '@/assets/icons/chevron-right-gray.svg'
import _imports_3 from '@/assets/icons/icon-arrow-back.svg'
import _imports_4 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "inclusions-view" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_4 = {
  key: 1,
  class: "packages-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "package-row-left" }
const _hoisted_7 = { class: "pkg-info" }
const _hoisted_8 = { class: "pkg-name" }
const _hoisted_9 = { class: "pkg-subtitle" }
const _hoisted_10 = { class: "package-row-right" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "view-header" }
const _hoisted_14 = { class: "header-left" }
const _hoisted_15 = { class: "title-main" }
const _hoisted_16 = { class: "header-actions" }
const _hoisted_17 = {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"margin-right":"6px"}
}
const _hoisted_18 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_19 = {
  key: 1,
  class: "categories-list"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "category-header-left" }
const _hoisted_22 = { class: "category-name" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "category-body" }
const _hoisted_26 = {
  key: 0,
  class: "category-items"
}
const _hoisted_27 = { class: "item-row-left" }
const _hoisted_28 = { class: "item-thumb-wrap" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "item-thumb-placeholder"
}
const _hoisted_31 = { class: "item-info" }
const _hoisted_32 = { class: "item-name" }
const _hoisted_33 = {
  key: 0,
  class: "item-desc"
}
const _hoisted_34 = { class: "item-row-right" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "category-empty"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "modal-content sm" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = { class: "modal-title" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "modal-footer" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "modal-content sm" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "modal-title" }
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "modal-footer" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = { class: "modal-title" }
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { class: "modal-footer" }
const _hoisted_62 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.view === 'list')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", { class: "view-header" }, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "title-main" }, "Inclusions Packages", -1)),
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.openCreateModal
            }, "+ Create Package")
          ]),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "spinner" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($setup.packages.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[9] || (_cache[9] = [
                      _createStaticVNode("<div class=\"empty-icon-wrap\" data-v-5509bd10><svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" data-v-5509bd10><path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path><path d=\"M3.27 6.96L12 12.01l8.73-5.05\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path><path d=\"M12 22.08V12\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path></svg></div><p class=\"empty-text\" data-v-5509bd10>No inclusion packages yet</p><p class=\"empty-hint\" data-v-5509bd10>Click &quot;Create Package&quot; to get started</p>", 3)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.packages, (pkg) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "package-row",
                          key: pkg._id,
                          onClick: ($event: any) => ($setup.openDetail(pkg))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"pkg-icon-wrap\" data-v-5509bd10><svg class=\"pkg-icon\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5509bd10><path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path><path d=\"M3.27 6.96L12 12.01l8.73-5.05\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path><path d=\"M12 22.08V12\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5509bd10></path></svg></div>", 1)),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(pkg.type), 1),
                              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.getCategoryCountText(pkg)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                              class: "action-btn",
                              type: "button",
                              onClick: _withModifiers(($event: any) => ($setup.openEditModal(pkg)), ["stop"]),
                              title: "Edit"
                            }, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Edit"
                              }, null, -1)
                            ]))], 8, _hoisted_11),
                            _createElementVNode("button", {
                              class: "action-btn danger",
                              type: "button",
                              onClick: _withModifiers(($event: any) => ($setup.confirmDelete(pkg)), ["stop"]),
                              title: "Delete"
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Delete"
                              }, null, -1)
                            ]))], 8, _hoisted_12),
                            _cache[13] || (_cache[13] = _createElementVNode("img", {
                              class: "chevron-icon",
                              src: _imports_2,
                              alt: ""
                            }, null, -1))
                          ])
                        ], 8, _hoisted_5))
                      }), 128))
                    ]))
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    ($setup.view === 'detail' && $setup.selectedPackage)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "back-btn",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.view = 'list'))
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("img", {
                  class: "back-icon",
                  src: _imports_3,
                  alt: "Back"
                }, null, -1),
                _createElementVNode("span", null, "Back", -1)
              ]))]),
              _createElementVNode("h2", _hoisted_15, _toDisplayString($setup.selectedPackage.type), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", {
                class: _normalizeClass(["button default outline bulk-upload-btn", { disabled: $setup.bulkUploading }])
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("path", {
                    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1),
                  _createElementVNode("polyline", {
                    points: "17 8 12 3 7 8",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "3",
                    x2: "12",
                    y2: "15",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]))])),
                _createElementVNode("span", null, _toDisplayString($setup.bulkUploading ? "Uploading..." : "Bulk Upload"), 1),
                _createElementVNode("input", {
                  ref: "bulkInputRef",
                  type: "file",
                  accept: ".xlsx",
                  style: {"display":"none"},
                  onChange: $setup.handleBulkUpload
                }, null, 544)
              ], 2),
              _createElementVNode("button", {
                class: "button default primary",
                onClick: $setup.openCreateCategoryModal
              }, "+ Add Category")
            ])
          ]),
          ($setup.localCategories.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("p", { class: "empty-text" }, "No categories in this package yet", -1),
                _createElementVNode("p", { class: "empty-hint" }, "Click \"Add Category\" to organize your items", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localCategories, (category, catIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "category-section",
                    key: catIdx
                  }, [
                    _createElementVNode("div", {
                      class: "category-header",
                      onClick: ($event: any) => ($setup.toggleCategory(catIdx)),
                      style: {"cursor":"pointer"}
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[18] || (_cache[18] = _createElementVNode("svg", {
                          class: "folder-icon",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          width: "16",
                          height: "16"
                        }, [
                          _createElementVNode("path", {
                            d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(category.name), 1),
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["chevron-toggle", { collapsed: $setup.collapsedCategories.has(catIdx) }]),
                          viewBox: "0 0 24 24",
                          fill: "none",
                          width: "14",
                          height: "14"
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("polyline", {
                            points: "18 15 12 9 6 15",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, null, -1)
                        ]))], 2))
                      ]),
                      _createElementVNode("div", {
                        class: "category-header-right",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("button", {
                          class: "action-btn-sm",
                          type: "button",
                          onClick: ($event: any) => ($setup.openEditCategoryModal(category, catIdx)),
                          title: "Edit category name"
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Edit"
                          }, null, -1)
                        ]))], 8, _hoisted_23),
                        _createElementVNode("button", {
                          class: "action-btn-sm danger",
                          type: "button",
                          onClick: ($event: any) => ($setup.confirmDeleteCategory(catIdx)),
                          title: "Delete category"
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Delete"
                          }, null, -1)
                        ]))], 8, _hoisted_24)
                      ])
                    ], 8, _hoisted_20),
                    _withDirectives(_createElementVNode("div", _hoisted_25, [
                      (category.items.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, (item, itemIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "item-row",
                                key: itemIdx
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    (item.url)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "item-thumb",
                                          src: item.url,
                                          alt: ""
                                        }, null, 8, _hoisted_29))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[21] || (_cache[21] = [
                                          _createElementVNode("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            width: "20",
                                            height: "20"
                                          }, [
                                            _createElementVNode("rect", {
                                              x: "3",
                                              y: "3",
                                              width: "18",
                                              height: "18",
                                              rx: "2",
                                              stroke: "currentColor",
                                              "stroke-width": "1.5"
                                            }),
                                            _createElementVNode("circle", {
                                              cx: "8.5",
                                              cy: "8.5",
                                              r: "1.5",
                                              stroke: "currentColor",
                                              "stroke-width": "1.5"
                                            }),
                                            _createElementVNode("path", {
                                              d: "M21 15l-5-5L5 21",
                                              stroke: "currentColor",
                                              "stroke-width": "1.5",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            })
                                          ], -1)
                                        ]))]))
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(item.name), 1),
                                    (item.description && item.description.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(item.description.join(" • ")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("button", {
                                    class: "action-btn",
                                    type: "button",
                                    onClick: ($event: any) => ($setup.openEditItemModal(item, catIdx, itemIdx))
                                  }, [...(_cache[22] || (_cache[22] = [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "Edit"
                                    }, null, -1)
                                  ]))], 8, _hoisted_35),
                                  _createElementVNode("button", {
                                    class: "action-btn danger",
                                    type: "button",
                                    onClick: ($event: any) => ($setup.confirmDeleteItem(catIdx, itemIdx))
                                  }, [...(_cache[23] || (_cache[23] = [
                                    _createElementVNode("img", {
                                      src: _imports_1,
                                      alt: "Delete"
                                    }, null, -1)
                                  ]))], 8, _hoisted_36)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("p", { class: "empty-text-sm" }, "No items yet", -1)
                          ]))])),
                      _createElementVNode("div", {
                        class: "add-item-row",
                        onClick: ($event: any) => ($setup.openCreateItemModal(catIdx))
                      }, [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("span", null, "+ Add Item", -1)
                      ]))], 8, _hoisted_38)
                    ], 512), [
                      [_vShow, !$setup.collapsedCategories.has(catIdx)]
                    ])
                  ]))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true),
    ($setup.showPackageModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closePackageModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h3", _hoisted_41, _toDisplayString($setup.isEditPackageMode ? "Edit Package" : "Create Package"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closePackageModal
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label" }, "Package Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.packageForm.name) = $event)),
                  placeholder: "e.g. Standard Inclusions",
                  onKeyup: _withKeys($setup.savePackage, ["enter"])
                }, null, 544), [
                  [_vModelText, $setup.packageForm.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closePackageModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.packageForm.name.trim() || $setup.savingPackage,
                onClick: $setup.savePackage
              }, _toDisplayString($setup.isEditPackageMode ? "Save Changes" : "Create"), 9, _hoisted_45)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showCategoryModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeCategoryModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", _hoisted_48, _toDisplayString($setup.isEditCategoryMode ? "Edit Category" : "Add Category"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closeCategoryModal
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label" }, "Category Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.categoryForm.name) = $event)),
                  placeholder: "e.g. Kitchen, Bathroom, Flooring",
                  onKeyup: _withKeys($setup.saveCategory, ["enter"])
                }, null, 544), [
                  [_vModelText, $setup.categoryForm.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closeCategoryModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.categoryForm.name.trim() || $setup.savingCategory,
                onClick: $setup.saveCategory
              }, _toDisplayString($setup.isEditCategoryMode ? "Save Changes" : "Add"), 9, _hoisted_52)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showItemModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeItemModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("h3", _hoisted_55, _toDisplayString($setup.isEditItemMode ? "Edit Item" : "Add Item"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                type: "button",
                onClick: $setup.closeItemModal
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Close"
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label" }, "Item Name *", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.itemNameError }]),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.itemForm.name) = $event)),
                  placeholder: "e.g. Bathroom"
                }, null, 2), [
                  [_vModelText, $setup.itemForm.name]
                ]),
                ($setup.itemNameError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, "Name is required"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label" }, "Description (optional)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea-desc",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.itemForm.description) = $event)),
                  placeholder: "e.g. 20mm Caesarstone benchtops to kitchen",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, $setup.itemForm.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label" }, "Image URL", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.itemForm.url) = $event)),
                  placeholder: "https://..."
                }, null, 512), [
                  [_vModelText, $setup.itemForm.url]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", {
                class: "button default cancel",
                type: "button",
                onClick: $setup.closeItemModal
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary",
                type: "button",
                disabled: !$setup.itemForm.name.trim() || $setup.savingItem,
                onClick: $setup.saveItem
              }, _toDisplayString($setup.isEditItemMode ? "Save Changes" : "Add Item"), 9, _hoisted_62)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}